import React from 'react';
import { ItineraryIItem } from 'views/rebranded-module/tours-module/TourViewV2/components/ItineraryIItem';
import {
  Timeline,
  TimelineSeparator,
  TimelineConnector,
  TimelineContent,
  TimelineDot,
  TimelineItem,
} from '@mui/lab';
import StyledBox from 'views/rebranded-module/tours-module/TourViewV2/components/ItinerarySection/ItinerarySection.styles';

const ItinerarySection = (props) => {
  const { activities, sameDayTour, cmsData } = props;

  return (
    <StyledBox>
      <Timeline className="ISTimeLine">
        {/* empty TimelineItem without Connector and content to to align with the styling in the Figma design */}
        <TimelineItem className="ISTimeIItem">
          <TimelineSeparator>
            <TimelineConnector className="ISTimelineConnector ISEmptyConnector" />
          </TimelineSeparator>
        </TimelineItem>
        {activities.map((activity) => (
          <TimelineItem className="ISTimeIItem" key={activity.title}>
            <TimelineSeparator>
              <TimelineDot className="ISTimelineDot" />
              <TimelineConnector className="ISTimelineConnector" />
            </TimelineSeparator>
            <TimelineContent className="ISTimelineContent">
              <ItineraryIItem
                activity={activity}
                sameDayTour={sameDayTour}
                cmsData={cmsData}
              />
            </TimelineContent>
          </TimelineItem>
        ))}
      </Timeline>
    </StyledBox>
  );
};

export { ItinerarySection };
